/* eslint-disable no-console */
'use strict'

import tippy from 'tippy.js'
import {Tracking, TrackingEvent} from '@common/tracking'

export class CommonController {
  private static isRegPopupOpen = false

  private static getScrollbarWidth(): number {
    const dummy = document.createElement('div')
    dummy.style.width = '100px'
    dummy.style.height = '100px'
    dummy.style.overflow = 'scroll'
    dummy.style.position = 'absolute'
    dummy.style.top = '-9999px'
    document.body.appendChild(dummy)
    const scrollbarWidth: number = dummy.offsetWidth - dummy.clientWidth
    document.body.removeChild(dummy)
    return scrollbarWidth
  }

  private static setRegError(el: Element, message: string): void {
    const err = el.querySelector<HTMLElement>('.s-reg-error')
    if (!err) {
      return
    }
    if (message) {
      err.textContent = message
      err.style.display = 'block'
    } else {
      err.style.display = 'none'
    }
  }

  private static registerModal(): void {
    const btns = document.querySelectorAll('.s-reg-click')
    for (const btn of Array.from(btns)) {
      btn.addEventListener('click', () => {
        const scrollbarWidth = this.getScrollbarWidth()
        document.body.style.paddingRight = scrollbarWidth + 'px'
        document.body.classList.add('s-reg-show', 'blur')
        document
          .querySelectorAll<HTMLInputElement>('.s-reg-cnt')
          .forEach(el => {
            CommonController.setRegError(el, '')
          })
        this.isRegPopupOpen = true
        requestAnimationFrame(() => {
          const input =
            document.querySelector<HTMLInputElement>('.s-reg-wnd input')
          input?.focus()
          // document.documentElement.scrollTop = 0;
        })
      })
    }

    const overlay = document.querySelector('.s-reg-wnd-overlay')
    overlay?.addEventListener('click', () => {
      document.body.classList.remove('s-reg-show')
      document.body.classList.remove('blur')
      this.isRegPopupOpen = false

      document.body.style.paddingRight = '0'
    })
  }

  private static boxRequestModal(): void {
    const btns = document.querySelectorAll('.s-box-click')
    for (const btn of Array.from(btns)) {
      btn.addEventListener('click', () => {
        const scrollbarWidth = this.getScrollbarWidth()
        document.body.style.paddingRight = scrollbarWidth + 'px'

        document
          .querySelectorAll<HTMLInputElement>('.s-reg-cnt')
          .forEach(el => {
            CommonController.setRegError(el, '')
          })

        if (
          btn.classList.contains('no-download') &&
          btn.classList.contains('s-box-click')
        ) {
          document.body.classList.remove('s-box-show', 'blur')
          document.body.classList.add('s-box-show-no-download', 'blur')

          const modal = document.querySelector('.s-box.no-download')
          modal?.setAttribute(
            'data-request-call-tracking-event-origin',
            btn.getAttribute('data-request-call-tracking-event-origin') ?? ''
          )
        } else if (
          !btn.classList.contains('no-download') &&
          btn.classList.contains('s-box-click')
        ) {
          document.body.classList.add('s-box-show', 'blur')
          document.body.classList.remove('s-box-show-no-download')
        }

        if (btn.classList.contains('platform')) {
          document.body.classList.add('s-box-show-platform')
        } else {
          document.body.classList.remove('s-box-show-platform')
        }
      })
    }

    const overlays = document.querySelectorAll('.modal-overlay')
    for (const overlay of Array.from(overlays)) {
      overlay.addEventListener('click', () => {
        document.body.classList.remove('s-box-show-no-download')
        document.body.classList.remove('s-box-show-platform')
        document.body.classList.remove('s-box-show')
        document.body.classList.remove('blur')

        const modal = document.querySelectorAll('.s-box')
        modal.forEach(el => {
          el.removeAttribute('data-request-call-tracking-event-origin')
        })

        document.body.style.paddingRight = '0'
      })
    }
  }

  private static vacancyModal(): void {
    const btns = document.querySelectorAll('.s-vacancy-click')
    for (const btn of Array.from(btns)) {
      btn.addEventListener('click', () => {
        const scrollbarWidth = this.getScrollbarWidth()
        document.body.style.paddingRight = scrollbarWidth + 'px'
        document.body.classList.add('s-vacancy-show', 'blur')

        const origin = btn.getAttribute(
          'data-request-vacancy-tracking-event-origin'
        )
        if (origin) {
          Tracking.send(TrackingEvent.landingOpenVacancyPopupFrom, {
            from: origin
          })
        }
      })
    }

    const modal = document.querySelector('.s-vacancy')
    modal
      ?.querySelector('.s-vacancy-tg-click')
      ?.addEventListener('click', () => {
        Tracking.send(TrackingEvent.landingClickOpenHrTgButtonFromPopup)
      })
    modal
      ?.querySelector('.s-vacancy-hh-click')
      ?.addEventListener('click', () => {
        Tracking.send(TrackingEvent.landingClickOpenHHButtonFromPopup)
      })

    const closeModal = modal?.querySelector('.modal-close.s-link')
    closeModal?.addEventListener('click', () => {
      document.body.classList.remove('s-vacancy-show')
      document.body.classList.remove('blur')
      document.body.style.paddingRight = '0'
    })

    const overlay = document.querySelector('.s-vacancy-overlay')
    overlay?.addEventListener('click', () => {
      document.body.classList.remove('s-vacancy-show')
      document.body.classList.remove('blur')
      this.isRegPopupOpen = false

      document.body.style.paddingRight = '0'
    })
  }

  private static langSwitch(): void {
    const langs = document.querySelectorAll('.s-lang')
    for (const lang of Array.from(langs)) {
      lang.addEventListener('click', (e: Event) => {
        e.stopPropagation()
        lang.classList.toggle('active')
      })
      document.addEventListener('click', () => {
        lang.classList.remove('active')
      })
    }
    const ru = document.querySelectorAll('.s-lang-wnd-item.ru')
    const en = document.querySelectorAll('.s-lang-wnd-item.en')
    const host = location.hostname
    const pageLang = (window as any).PAGE_LANG
    for (const el of Array.from(ru)) {
      el.addEventListener('click', () => {
        if (host === 'yougile.com' || host === 'en.yougile.com') {
          location.hostname = 'ru.yougile.com'
        }
        if (host === 'test.yougile.com' || host === 'test-en.yougile.com') {
          location.hostname = 'test-ru.yougile.com'
        }
        if (host === 'localhost' && pageLang !== 'ru') {
          location.search = '?lang=ru'
        }
      })
    }
    for (const el of Array.from(en)) {
      el.addEventListener('click', () => {
        if (host === 'yougile.com' || host === 'ru.yougile.com') {
          location.hostname = 'en.yougile.com'
        }
        if (host === 'test.yougile.com' || host === 'test-ru.yougile.com') {
          location.hostname = 'test-en.yougile.com'
        }
        if (host === 'localhost' && pageLang !== 'en') {
          location.search = '?lang=en'
        }
      })
    }
  }

  private static copyrightDate(): void {
    const year = new Date().getFullYear()
    const el = document.querySelector('.s-copyright')
    if (el) {
      el.textContent = `Copyright © ${year} YouGile`
    }
  }

  private static initTooltips(): void {
    const elements = document.querySelectorAll('[data-tippy-content]')
    tippy(elements, {
      interactive: true
    })
  }

  private static redHelperLazyload(): void {
    const targetSelector = 'footer'
    const scriptSrc = 'https://web.redhelper.ru/service/main.js?c=yougile'

    const loadScript = (): void => {
      const script = document.createElement('script')
      script.id = 'rhlpscrtg'
      script.src = scriptSrc
      script.async = true
      document.body.appendChild(script)
    }

    const options: IntersectionObserverInit = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    }

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        // console.log('Intersection ratio:', entry.intersectionRatio)
        if (entry.isIntersecting) {
          // console.log('Target entered viewport. Loading script...')
          loadScript()
          observer.unobserve(entry.target)
        }
      })
    }, options)

    const target = document.querySelector(targetSelector)
    if (target) {
      observer.observe(target)
      // console.log('Observer started observing target element:', targetSelector)
    } else {
      // console.error('Target element not found:', targetSelector)
    }
  }

  public static start(): void {
    this.langSwitch()
    this.copyrightDate()
    this.registerModal()
    this.boxRequestModal()
    this.vacancyModal()
    this.initTooltips()
    this.redHelperLazyload()
  }
}
